import {
  CalculateCancellationPenaltyRequest,
  CancelBookingRequest,
  CreateBookingRequest,
  GetBookingStatusRequest,
} from '@/api/generated/fetch-client';
import { RepositoryException, WithSignal } from '@/types/typings';

import { BookingApi } from '../api';

export class BookingRepository {
  constructor(private readonly bookingApi: BookingApi) {}

  public async createBooking(requestParameters: WithSignal<CreateBookingRequest>) {
    const data = await this.bookingApi.createBooking(requestParameters);

    if (!data) {
      throw new RepositoryException('repository createBooking error');
    }

    return data;
  }

  public async cancelBooking(requestParams: CancelBookingRequest) {
    const data = await this.bookingApi.cancelBooking(requestParams);

    if (!data) {
      throw new RepositoryException('repository cancelBooking error');
    }

    return data;
  }

  public async calculateCancellationPenalty(
    requestParams: WithSignal<CalculateCancellationPenaltyRequest>,
  ) {
    const data = await this.bookingApi.calculateCancellationPenalty(requestParams);

    if (!data) {
      throw new RepositoryException('repository calculateCancellationPenalty error');
    }

    return data;
  }

  public async getBookingStatus(requestParams: WithSignal<GetBookingStatusRequest>) {
    const data = await this.bookingApi.getBookingStatus(requestParams);

    if (!data) {
      throw new RepositoryException('repository getBookingStatus error');
    }

    return data;
  }
}
